import {ElementRef, Directive, HostListener} from "@angular/core";
/**
 * Created by nijin on 9/10/17.
 */
@Directive({
  selector: '[numberOnly]'
})
export class NumberOnly {

  constructor(private el: ElementRef) {
  }

@HostListener('keypress', ['$event'])
  onKeyPress(event){
    let keyCode = event.keyCode || event.which;
  if(keyCode !== 8 && keyCode !== 46 && (keyCode < 48 || keyCode > 57 )) {
    event.preventDefault();
  }
}

}



// WEBPACK FOOTER //
// ./src/app/shared/number-only.directive.ts